(function (app) {
    app.provider("fileUploadApi", [function () {
        this.$get = ["dataFeedApiGateway", "Upload", function (dataFeedApiGateway, Upload) {
            var service = {};

            service.uploadFile = async (file, trackId) => {
                return dataFeedApiGateway.postFile("/SftpAPI/FileHandler?trackId=" + trackId, file);
            };

            return service;
        }];
    }]);
})(window.app);
